var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cont"},[_c('div',{staticClass:"bottom"},[_vm._v(" CopyRight @ DIXCEL中国 "+_vm._s(_vm.year)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }